export var ToolbarDataType;
(function (ToolbarDataType) {
    ToolbarDataType["SingleButton"] = "s-button";
    ToolbarDataType["ListButton"] = "list-b";
    ToolbarDataType["ReactNode"] = "r-node";
    ToolbarDataType["ReactNodeFn"] = "r-node-fn";
    ToolbarDataType["ReactComponent"] = "r-component";
})(ToolbarDataType || (ToolbarDataType = {}));
